export const getAlertsApiEndpoint = () => {
    const baseSiteId = localStorage.getItem('baseSiteId');
    return baseSiteId
        ? `/occ/v2/${baseSiteId}/alerts/alertsList`
        : 'alerts/alertsList';
};
